import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/service-centers`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/service-centers/${id}?include=organization,allowedUsers,allowedUsers.roles`,
      options
    )
    .then((response) => {
      let serviceCenter = jsona.deserialize(response.data);
      delete serviceCenter.links;
      return serviceCenter;
    });
}

function add(serviceCenter) {
  const payload = jsona.serialize({
    stuff: serviceCenter,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/service-centers?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(serviceCenter) {
  const payload = jsona.serialize({
    stuff: serviceCenter,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/service-centers/${serviceCenter.id}?include=`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/service-centers/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
